(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-wheel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dialogs = document.querySelectorAll('.email-wheel');

    dialogs.forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;

      const form = dialog.querySelector('.email-wheel__form');
      const wheel = dialog.querySelector('.email-wheel__disc');
      const closeButton = dialog.querySelector('.email-wheel__close');
      const declineButton = dialog.querySelector('.email-wheel__decline');
      const submitButton = dialog.querySelector('.email-wheel__submit');
      const errorMessage = dialog.querySelector('.email-wheel__error');
      const result = dialog.querySelector('.email-wheel__result');
      const prizeText = dialog.querySelector('.email-wheel__prize');
      const codeWrap = dialog.querySelector('.email-wheel__code-wrap');
      const codeText = dialog.querySelector('.email-wheel__code');
      const copyButton = dialog.querySelector('.email-wheel__copy');
      const shippingNote = dialog.querySelector('.email-wheel__shipping-note');
      const storageKey = 'ideia-forma-email-wheel';
      const cooldownDays = Number(dialog.dataset.cooldown || 14);
      const delay = Number(dialog.dataset.delay || 5000);
      const shopifyContext = window.Shopify || {};
      const isThemePreview =
        dialog.dataset.designMode === 'true' ||
        shopifyContext.designMode === true ||
        shopifyContext.visualPreviewMode === true ||
        new URLSearchParams(window.location.search).has('preview_theme_id');

      const outcomes = [
        { label: dialog.dataset.prizeFive, code: dialog.dataset.codeFive, shipping: false },
        { label: dialog.dataset.prizeTry, code: '', shipping: false },
        { label: dialog.dataset.prizeShipping, code: dialog.dataset.codeShipping, shipping: true },
        { label: dialog.dataset.prizeFive, code: dialog.dataset.codeFive, shipping: false },
        { label: dialog.dataset.prizeTen, code: dialog.dataset.codeTen, shipping: false },
        { label: dialog.dataset.prizeTry, code: '', shipping: false },
      ];

      const hideDialog = () => {
        if (dialog.open) dialog.close();
      };

      const rememberVisit = () => {
        if (isThemePreview) return;
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          return;
        }
      };

      const canShow = () => {
        if (isThemePreview) return true;
        try {
          const lastVisit = Number(localStorage.getItem(storageKey) || 0);
          return Date.now() - lastVisit > cooldownDays * 86400000;
        } catch (error) {
          return true;
        }
      };

      const openTimer = window.setTimeout(() => {
        if (canShow() && !dialog.open) dialog.showModal();
      }, isThemePreview ? 600 : delay);

      closeButton?.addEventListener('click', () => {
        rememberVisit();
        hideDialog();
      });

      declineButton?.addEventListener('click', () => {
        rememberVisit();
        hideDialog();
      });

      dialog.addEventListener('cancel', () => {
        rememberVisit();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          rememberVisit();
          hideDialog();
        }
      });

      copyButton?.addEventListener('click', async () => {
        if (!codeText?.textContent) return;
        await navigator.clipboard.writeText(codeText.textContent.trim());
        copyButton.textContent = '✓';
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!(form instanceof HTMLFormElement) || !form.reportValidity()) return;

        submitButton.disabled = true;
        errorMessage.hidden = true;

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) throw new Error('Subscription failed');

          const selectedIndex = Math.floor(Math.random() * outcomes.length);
          const rotations = 6;
          const segmentAngle = 60;
          const targetAngle = rotations * 360 + (360 - selectedIndex * segmentAngle);
          wheel.style.transform = `rotate(${targetAngle}deg)`;
          rememberVisit();

          window.setTimeout(() => {
            const outcome = outcomes[selectedIndex];
            form.hidden = true;
            result.hidden = false;
            prizeText.textContent = outcome.label;

            if (outcome.code) {
              codeText.textContent = outcome.code;
              codeWrap.hidden = false;
              shippingNote.hidden = !outcome.shipping;
            } else {
              codeWrap.hidden = true;
              shippingNote.hidden = true;
            }

            declineButton.hidden = true;
          }, 4700);
        } catch (error) {
          errorMessage.hidden = false;
          submitButton.disabled = false;
        }
      });

      window.addEventListener('pagehide', () => window.clearTimeout(openTimer), { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faixa-categorias-ideia-forma"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-category-carousel]').forEach((root) => {
        if (root.dataset.carouselReady === 'true') return;
        root.dataset.carouselReady = 'true';

        const track = root.querySelector('[data-carousel-track]');
        const previous = root.querySelector('[data-carousel-previous]');
        const next = root.querySelector('[data-carousel-next]');
        const items = Array.from(track.children);
        if (items.length < 2) return;

        const stepSize = () => {
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
          return items[0].getBoundingClientRect().width + gap;
        };

        const move = (direction) => {
          const atStart = track.scrollLeft <= 2;
          const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2;

          if (direction > 0 && atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }

          if (direction < 0 && atStart) {
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
            return;
          }

          track.scrollBy({ left: direction * stepSize(), behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));

        let timer;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const interval = Number(root.dataset.speed) || 5000;

        const stop = () => {
          window.clearInterval(timer);
        };

        const start = () => {
          if (root.dataset.autoplay !== 'true' || reducedMotion) return;
          stop();
          timer = window.setInterval(() => move(1), interval);
        };

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        root.addEventListener('touchstart', stop, { passive: true });
        root.addEventListener('touchend', start, { passive: true });
        start();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
